/* eslint-disable ember/no-classic-components, ember/no-component-lifecycle-hooks, ember/no-mixins */
import Component from '@ember/component';
import { and } from '@ember/object/computed';
import FocusableMixin from 'ember-paper/mixins/focusable-mixin';
import ValidationMixin from 'ember-paper/mixins/validation-mixin';

export default class InputLabel extends Component.extend(
  FocusableMixin,
  ValidationMixin,
) {
  tagName = 'md-input-container';
  classNames = ['md-default-theme'];
  classNameBindings = [
    'hasValue:md-input-has-value',
    'focused:md-input-focused',
    'block:md-block',
    'isInvalidAndTouched:md-input-invalid',
  ];
  attributeBindings = ['tabindex'];

  // md-input-container is a wrapper, never keyboard-focusable itself.
  // Overrides FocusableMixin's `tabindex` computed with a plain getter.
  get tabindex() {
    return -1;
  }

  validationProperty = 'content';

  // Mark field as invalid only if also touched. Computed (not a plain getter)
  // so the `md-input-invalid` classNameBinding re-evaluates when the form
  // sets `isTouched` on submit.
  @and('isInvalid', 'isTouched') isInvalidAndTouched;

  // Register with the parent form when one is supplied, matching ember-paper's
  // built-in fields.
  didInsertElement() {
    super.didInsertElement(...arguments);
    if (this.parentComponent) {
      this.parentComponent.register(this);
    }
  }

  willDestroyElement() {
    super.willDestroyElement(...arguments);
    if (this.parentComponent) {
      this.parentComponent.deRegister(this);
    }
  }
}
